/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const PopUpBox = styled.div`
  width: 250px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  gap: 8px;
  background-color: #fff;
  ${({ location }) =>
    location === 'bulkActions' &&
    css`
      border: 1px solid #e2e8f0;
      box-shadow: 0px 0px 18px 0px rgba(23, 43, 77, 0.08), 0px 8px 24px 0px rgba(23, 43, 77, 0.08);
    `}
`;

export const FlexWrap = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const LoaderWrap = styled.div`
  transform: translateY(-10px);
  margin: 0 auto;
`;
